import React from 'react';
import TariffCardWrapper from '~/src/components/LandingBlock/Tariffs/TariffCard';
import TariffsCarousel from '../TariffsCarousel';
import type { ITariffFull } from '~/src/services/tariffs/types';
import type { TCardButtonProps } from '~/src/components/LandingBlock/TariffCardsRA/CardRA';

interface TariffRendererProps {
    tariffs: ITariffFull[];
    isCarouselActive: boolean;
    isFullByActive: boolean;
    buttonProps: TCardButtonProps;
    cityDomain: string;
    handleOpenModal: (tariff: ITariffFull) => void;
}

const TariffRenderer = ({
    tariffs,
    isCarouselActive,
    isFullByActive,
    buttonProps,
    cityDomain,
    handleOpenModal,
}: TariffRendererProps): JSX.Element =>
    isCarouselActive
    ? (
        <TariffsCarousel
            tariffs={tariffs}
            isFullByActive={isFullByActive}
            buttonProps={buttonProps}
            cityDomain={cityDomain}
            handleOpenModal={handleOpenModal}
        />
    )
    : (
        <>
            {tariffs.map((tariff) => (
                <TariffCardWrapper
                    key={tariff.productId}
                    tariff={tariff}
                    isFullByActive={isFullByActive}
                    idForScroll={buttonProps.idForScroll}
                    buttonProps={buttonProps}
                    cityDomain={cityDomain}
                    openModal={async () => handleOpenModal(tariff)}
                />
            ))}
        </>
    );

export default TariffRenderer;
